if (!customElements.get('product-card')) {
  customElements.define(
    'product-card',
    class ProductCard extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        // Selectors
        this.radios = this.querySelectorAll('input[type="radio"]');
        this.regiosItem = this.querySelector('[data-regios-dopp-generic-product-id]');
        this.short_description = this.querySelector('.boost-sd__product-short-description');
        if (
          this.short_description &&
          this.short_description.hasAttribute('data-short-description') &&
          this.short_description?.dataset?.shortDescription !== ''
        ) {
          const data = JSON.parse(this.short_description.dataset.shortDescription);
          if (data && data?.children?.[0]?.children?.length > 0) {
            const shortDescription = data?.children?.[0]?.children?.map((child) => child?.value).join('');
            this.short_description.innerHTML = shortDescription;
          }
        }

        this.product = {};
        if (this.querySelector('[data-product-js]') && this.querySelector('[data-product-js]').innerHTML !== '') {
          const productJson = JSON.parse(this.querySelector('[data-product-js]').innerHTML);
          this.product = this.validateProductObject(productJson);
        }
        this.selectedVariant = this.getVariantFromId(this.dataset.variantId);

        this.variantDetails = {};
        this.variantDetails = this.isJsonString(this?.dataset?.variant_details)
          ? JSON.parse(this?.dataset?.variant_details)
          : {};

        this.updateBadges();
        if (this.selectedVariant?.id) {
          if (window.RegiosDOPP?.api?.v0) {
            this.updateRegiosDiscount(this.selectedVariant.id);
          } else {
            window.addEventListener('regios-dopp:api-initialized', () => {
              this.updateRegiosDiscount(this.selectedVariant.id);
            });
          }
        }

        // Events
        this.radio_events = [];
        this.radios.forEach((radio) => {
          const handler = this.updateSelection.bind(this);
          radio.addEventListener('click', handler);
          this.radio_events.push({ radio, handler });
        });
        this.content_updated_handler = this.contentUpdated.bind(this);
        this.addEventListener('content-updated', this.content_updated_handler);
        this.addEventListener('click', this.handleClick.bind(this));
      }

      handleClick(e) {
        if (
          e.target.closest('.boost-sd__product-swatch-more') ||
          e.target.classList.contains('boost-sd__product-swatch-more')
        ) {
          const link = this.querySelector('a.boost-sd__product-link');
          if (link) {
            link.click();
          }
        }
        e.stopImmediatePropagation();
        e.stopPropagation();
      }

      connectedCallback() {
        this.destroy();
        this.init();
      }

      disconnectedCallback() {
        this.destroy();
      }

      destroy() {
        this.radio_events.forEach(({ radio, handler }) => {
          radio.removeEventListener('click', handler);
        });
        this.removeEventListener('content-updated', this.content_updated_handler);
      }

      contentUpdated() {
        this.destroy();
        this.init();
      }

      updateDisplay(activeRadio) {
        const label = activeRadio.nextElementSibling;
        const variantImgUrl = activeRadio.dataset.variantImage;
        const variantUrl = activeRadio.dataset.variantUrl;
        const price = label.querySelector('.tile-option-price .price');
        const productId = activeRadio.id && activeRadio.id.indexOf('-') > -1 ? activeRadio.id.split('-')[0] : null;
        let variantId = null;
        const selectedOption = `${activeRadio.dataset.swatchType}:${activeRadio.value}`;
        this.selectedVariant = this.getSelectedVariant(selectedOption);
        if (variantImgUrl) {
          const newImagePath = variantImgUrl.split('?')[0];
          const img = this.querySelector('.card__media .media img');

          const srcQuery = img.src.includes('?') ? '?' + img.src.split('?')[1] : '';
          img.src = `${newImagePath}${srcQuery}`;

          if (img.srcset) {
            const updatedSrcset = img.srcset
              .split(',')
              .map((set) => {
                const [urlPart, size] = set.trim().split(' ');
                const query = urlPart.split('?')[1] || '';
                return `${newImagePath}?${query} ${size}`;
              })
              .join(', ');
            img.srcset = updatedSrcset;
          }
        }

        if (variantUrl) {
          // Read off a data attribute, then written back into link hrefs and a
          // regex replacement - only accept a plain positive integer id.
          variantId = sanitizeShopifyId(new URLSearchParams(variantUrl.split('?')[1]).get('variant'));
        } else if (this.selectedVariant) {
          variantId = sanitizeShopifyId(this.selectedVariant.id);
        }
        this.updateProductUrlWithVariant(variantId);
        this.updateBadges();

        if (price) {
          if (this.querySelector('.card-information .price')) {
            this.querySelector('.card-information .price').innerHTML = price.innerHTML;
          }
          if (this.querySelector('.card__information > .price')) {
            this.querySelector('.card__information > .price').innerHTML = price.innerHTML;
          }
          // Refresh regios discount on tile
          if (productId != null && variantId != null) {
            this.querySelector('[data-variant-id][data-product-id]')?.setAttribute('data-variant-id', variantId);
            regiosCollectionPageVariantChange(productId, variantId, this.regios_collection_key);
          }
        }
      }

      updateSelection(e) {
        const activeRadio = e.target;
        this.updateDisplay(activeRadio);
      }

      formatRegiosPrice(price) {
        return parseInt(price.toFixed(2).toString().replace(/\D/g, ''), 10);
      }

      updateRegiosDiscount(variantId) {
        if (!window.RegiosDOPP?.api?.v0 || !variantId) return;
        const api = window.RegiosDOPP.api.v0;
        const regiosItem = this.querySelector('[data-regios-tile-data]');
        if (regiosItem && regiosItem.dataset.regiosTileData && regiosItem.dataset.regiosTileData !== '') {
          const regiosTileData = JSON.parse(regiosItem.dataset.regiosTileData);
          regiosItem.dataset.variantId = variantId;
          if (regiosTileData) {
            regiosTileData.variantId = variantId;
            regiosItem.dataset.regiosTileData = JSON.stringify(regiosTileData);
          }
          api.themeInterop.updateOnPagePrices(regiosItem, 'COLLECTION_PAGE', regiosTileData);
          api.calculateDiscountedPrices(regiosTileData).then(({ badge }) => {
            if (badge?.html && regiosItem.querySelector('.product-badge.product-badge-regios')) {
              regiosItem.querySelector('.product-badge.product-badge-regios').innerHTML = badge.html;
            }
          });
        }
      }

      validateProductObject(product) {
        if (typeof product !== 'object') {
          throw new TypeError(product + ' is not an object.');
        }

        return product;
      }

      getSelectedVariant(option) {
        if (!this.product || !this?.product?.variants || !option) return null;
        return this.product.variants.find(
          (variant) => variant.original_merged_options?.includes(option) || variant.merged_options?.includes(option)
        );
      }

      getVariantFromId(id) {
        if (!this.product || !this.product.variants || !id) return null;
        return this.product.variants.find((variant) => variant.id === parseInt(id)) || null;
      }

      updateProductUrlWithVariant(variantId) {
        if (!variantId) return;
        const targetedAttributes = ['href', 'data-product-url', 'data-url'];
        this.querySelectorAll('.variant-updated-url, .boost-sd__product-link').forEach((el) => {
          const variantUrl = this.getUrlWithVariant(el.href, variantId);
          targetedAttributes.forEach((attr) => {
            if (el.hasAttribute(attr)) {
              el.setAttribute(attr, variantUrl);
            }
          });
        });
      }

      getUrlWithVariant(url, id) {
        if (/variant=/.test(url)) {
          return url.replace(/(variant=)[^&]+/, '$1' + id);
        } else if (/\?/.test(url)) {
          return url.concat('&variant=').concat(id);
        }

        return url.concat('?variant=').concat(id);
      }

      updateBadges() {
        this.badges = this.querySelector('.product-badges');
        if (!this.badges) return;

        this.badges.innerHTML = '';
        let pageType = 'collection';
        if (this.closest('.boost-sd-container-search-page')) {
          pageType = 'search';
        }
        const variantDetails = this.variantDetails;
        const normalized_tags =
          this.product.tags && this.product.tags.length > 0 ? this.product.tags.join(',').toLowerCase().split(',') : '';
        const has_dwo_tag = normalized_tags.indexOf('dwo') > -1;
        const variantBadges = this.getVariantBadges(variantDetails, has_dwo_tag);
        const selectedVariantBadge = variantBadges.find((badge) => badge.variantId === `${this.selectedVariant.id}`);
        const productBadge = this.getProductBadge(this.product, has_dwo_tag, pageType);
        let badgeText = `<div
                            class="card__badge ${
                              [shopifyText.soldOut, shopifyText.comingSoon].indexOf(productBadge.value) > -1
                                ? 'hidden'
                                : ''
                            }"
                          >
                            <span class="product-badge product-badge-regios badge"></span>
                          </div>`;
        if (productBadge?.value !== '' || selectedVariantBadge?.value !== '') {
          badgeText += `${
            selectedVariantBadge
              ? `<div class="product-badge product-badge-${selectedVariantBadge.name || ''}">${
                  selectedVariantBadge.value || ''
                }</div>`
              : `<div class="product-badge product-badge-${(productBadge.name || '')
                  .toLowerCase()
                  .replace(/\s+/g, '-')}">${productBadge.value || ''}</div>`
          }`;
        }
        this.badges.innerHTML = badgeText;
      }

      getBadgeTranslation(badgeText) {
        const translations = shopifyText.badges;
        const translationKey = badgeText.toLowerCase().replaceAll(' ', '_');
        return translations[translationKey] || badgeText;
      }

      getVariantBadges(variantDetails, has_dwo_tag) {
        if (!variantDetails || !variantDetails.picks) return [];

        const variantBadges = (variantDetails.picks || []).reduce((acc, pick) => {
          const variant = pick.variant;
          const badgeText = variant.badgeText || [];
          const badgeAuto = variant.badgeAuto || '';

          if (badgeAuto.length && badgeAuto !== shopifyText.soldOut) {
            acc.push({
              variantId: variant.id,
              name: this.getBadgeTranslation(badgeAuto).toLowerCase().replace(/\s+/g, '-'),
              value: this.getBadgeTranslation(badgeAuto)
            });
          } else if (badgeText.length) {
            if (has_dwo_tag && (badgeText[0] === shopifyText.new || badgeText[0] === shopifyText.comingSoon)) {
            } else {
              acc.push({
                variantId: variant.id,
                name: (badgeText[0] || '').toLowerCase().replace(/\s+/g, '-'),
                value: badgeText[0] || ''
              });
            }
          } else if (has_dwo_tag) {
            acc.push({
              variantId: variant.id,
              name: 'past-season-picks',
              value: shopifyText.pastSeasonPicks
            });
          }
          return acc;
        }, []);

        return variantBadges;
      }

      getProductBadge(hit, has_dwo_tag, pageType) {
        let badgeTextMetafield = [];
        let badgeText = [];
        let badgeAuto = '';
        if (this?.selectedVariant?.id) {
          badgeTextMetafield =
            (this.product?.metafields || []).find(
              (metafield) =>
                metafield.namespace === 'rvw' &&
                metafield.key === 'badge_text' &&
                metafield?.id === this.selectedVariant.id
            )?.value || [];
          badgeAuto =
            (this.product?.metafields || []).find(
              (metafield) =>
                metafield.namespace === 'rvw' &&
                metafield.key === 'badge_auto' &&
                metafield?.id === this.selectedVariant.id
            )?.value || '';
        } else {
          badgeTextMetafield =
            (this.product?.metafields || []).find(
              (metafield) => metafield.namespace === 'rvw' && metafield.key === 'badge_text' && !metafield?.id
            )?.value || [];
          badgeAuto =
            (this.product?.metafields || []).find(
              (metafield) => metafield.namespace === 'rvw' && metafield.key === 'badge_auto' && !metafield?.id
            )?.value || '';
        }
        badgeText = badgeTextMetafield && this.isJsonString(badgeTextMetafield) ? JSON.parse(badgeTextMetafield) : [];

        const variantDetails = this.variantDetails;

        let result = {
          name: '',
          value: ''
        };

        if (badgeAuto.length && badgeAuto === shopifyText.comingSoon && !has_dwo_tag) {
          result.name = badgeAuto.toLowerCase().replace(/\s+/g, '-');
          result.value = this.getBadgeTranslation(badgeAuto);
        } else if (pageType === 'recommend' && variantDetails.picks?.length === 0) {
          result.name = 'sold-out';
          result.value = shopifyText.soldOut;
        } else if (pageType === 'search' && badgeAuto === shopifyText.soldOut) {
          result.name = badgeAuto.toLowerCase().replace(/\s+/g, '-');
          result.value = badgeAuto;
        } else if (pageType === 'search' && !hit.available) {
          result.name = 'sold-out';
          result.value = shopifyText.soldOut;
        } else if (badgeAuto.length && badgeAuto !== shopifyText.soldOut) {
          if (has_dwo_tag && (badgeAuto === shopifyText.new || badgeAuto === shopifyText.comingSoon)) {
            result.name = '';
            result.value = '';
          } else {
            result.name = badgeAuto.toLowerCase().replace(/\s+/g, '-');
            result.value = this.getBadgeTranslation(badgeAuto);
          }
        } else if (badgeText.length) {
          if (has_dwo_tag && (badgeText[0] === shopifyText.new || badgeText[0] === shopifyText.comingSoon)) {
            result.name = '';
            result.value = '';
          } else {
            result.name = (badgeText[0] || '').toLowerCase().replace(/\s+/g, '-');
            result.value = this.getBadgeTranslation(badgeText[0]);
          }
        } else if (has_dwo_tag) {
          result.name = 'past-season-picks';
          result.value = shopifyText.pastSeasonPicks;
        }

        return result;
      }

      isJsonString(str) {
        try {
          JSON.parse(str);
        } catch (e) {
          return false;
        }
        return true;
      }
    }
  );
}
